module.exports = __webpack_public_path__ + "media/images/diamonds_r-e20f3e33e6e35b4eec8f284f1851c76d.png";